import apiClient from './apiClient';

const emailTemplatesService = {
  getTemplates: async () => {
    const response = await apiClient.get('/settings/email-templates');
    return response.data;
  },

  getTemplate: async (name) => {
    const response = await apiClient.get(`/settings/email-templates/${name}`);
    return response.data;
  },

  updateTemplate: async (name, { subject, htmlBody, title, description }) => {
    const response = await apiClient.put(`/settings/email-templates/${name}`, { subject, htmlBody, title, description });
    return response.data;
  },

  sendTestEmail: async () => {
    const response = await apiClient.post('/settings/email/test');
    return response.data;
  },

  getSmtpConfig: async () => {
    const response = await apiClient.get('/settings/email-templates/smtp/config');
    return response.data;
  },

  updateSmtp: async (smtpData) => {
    const response = await apiClient.put('/settings/email-templates/smtp', smtpData);
    return response.data;
  },
};

export default emailTemplatesService;
